export const LOGIN = 'LOGIN';
export const AUTH_FETCH = 'AUTH_FETCH';
export const AUTH_RESOLVE = 'AUTH_RESOLVE';
export const AUTH_REJECT = 'AUTH_REJECT';
export const AUTH_CANCEL = 'AUTH_CANCEL';
export const TOKEN_REFRESH = 'TOKEN_REFRESH';